import html from "../../assests/icons8-html-logo-48.png";
import css from "../../assests/icons8-css-logo-480.png";
import bootstrap from "../../assests/icons8-bootstrap-480.png";
import tailwind from "../../assests/icons8-tailwind-css-480.png";
import js from "../../assests/icons8-javascript-480.png";
import ts from "../../assests/icons8-typescript-1000.png";
import reactjs from "../../assests/icons8-react-js-1000.png";
import nodejs from "../../assests/icons8-nodejs-1000.png";
import expressjs from "../../assests/icons8-express-js-1000.png";
import mongodb from "../../assests/icons8-mongodb-1000.png";
import postgresql from "../../assests/icons8-postgresql-1000.png";
import git from "../../assests/icons8-git-1000.png";
import github from "../../assests/icons8-github-500.png";
import java from "../../assests/icons8-java-1500.png";

const row1 = [html, css, bootstrap, tailwind, js, ts, reactjs];

const row2 = [nodejs, expressjs, mongodb, postgresql, git, github, java];

export { row1, row2 };
